<script lang="ts" setup>
defineProps<{
  notification: {
    title: string
    time: number
  }
}>()
</script>

<template>
  <div>
    <Text size="sm">
      {{ notification.title }}
    </Text>
    <Text
      size="xs"
      class="text-gray-400"
    >
      {{ timeAgo.format(notification.time) }}
    </Text>
  </div>
</template>
